'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var CoreActions_web_styles = require('./CoreActions.web.styles.cjs');

/**
 * Description added in ProductCard.web.tsx
 */ const CoreActions = ({ children })=>{
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: CoreActions_web_styles.coreActions,
        children: children
    });
};

exports.CoreActions = CoreActions;
//# sourceMappingURL=CoreActions.web.cjs.map
